import api from "../..";
import type { GetPostByIdParams, GetPostsParams, Post, PostDetail } from "./types";

export const getPosts = async (input: GetPostsParams = {}): Promise<Post[]> => {

  const { params } = input;

  return await api.get("/admin/posts/", { params })
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getPostById = async ({ id }: GetPostByIdParams): Promise<PostDetail | null> => {

  return await api.get(`/admin/posts/${id}/`)
  .then(res => res.data.data)
  .catch(() => null);
};
